/**
 * @file _view/qa-accordion.js
 */
(function ($) {
	'use strict';

	/**
	 * @namespace QaAccordion
	 * @constructor
	 * @classdesc dl使ったaccordion
	 * @param {Object} $e -対象となる jQuery オブジェクト
	 */
	var QaAccordion = function ($e) {
		this._$e      = $e;
		this._$target = this._$e.next('dd');
		this._$e.on('click', this.toggle.bind(this));
	};

	/**
	 * @memberOf QaAccordion
	 * @const
	 */
	QaAccordion._classname = 'QaAccordion';


	/**
	 * 'is-open'があるかどうかcheck
	 *
	 * @memberOf QaAccordion
	 */
	QaAccordion.prototype.toggle = function () {
		if (this._$e.hasClass('is-open')) {
			this.hide();
		} else {
			this.show();
		}
	};


	/**
	 * open accordion
	 *
	 * @memberOf QaAccordion
	 */
	QaAccordion.prototype.show = function () {
		this._$e.addClass('is-open');
		this._$target.slideDown();
	};


	/**
	 * close accordion
	 *
	 * @memberOf QaAccordion
	 */
	QaAccordion.prototype.hide = function () {
		this._$e.removeClass('is-open');
		this._$target.slideUp();
	};

	module.exports = QaAccordion;
})(jQuery);